import { useLightMode } from '@/hooks/useLightMode'
import { useTranslation } from 'react-i18next'
import { HiOutlineInformationCircle } from 'react-icons/hi'

import { Alert, AlertProps, Box, Icon } from '@chakra-ui/react'

import { AiOperatorModelT, Criterion } from '../types/types'

interface DefaultModelAlertIProps extends AlertProps {
  criteria: Criterion[]
  defaultAiOperatorModel?: AiOperatorModelT | null
  isImplementer?: boolean
}

export const DefaultModelAlert = ({
  criteria,
  defaultAiOperatorModel,
  isImplementer = false,
  ...props
}: DefaultModelAlertIProps) => {
  const { t } = useTranslation()
  const mode = useLightMode()

  if (!isImplementer || !defaultAiOperatorModel) {
    return null
  }

  const defaultCount = criteria.filter((c) => !c.aiOperatorModelId).length

  if (defaultCount === 0) {
    return null
  }

  const pluralizedMessage =
    defaultCount === 1
      ? t('automations:default_model_alert_criterion')
      : t('automations:default_model_alert_criteria')
  const message = `${defaultCount} ${pluralizedMessage} `

  return (
    <Alert
      bg={`bg.alert-info.${mode}`}
      borderRadius='10px'
      color={`text.alert-info.${mode}`}
      mb={4}
      status='info'
      {...props}
    >
      <Icon
        as={HiOutlineInformationCircle}
        boxSize='20px'
        color={`text.alert-info.${mode}`}
        mr='10px'
      />
      <Box fontSize='13px' fontWeight={400}>
        {message}
        <Box as='span' fontWeight={500}>
          {defaultAiOperatorModel.canonicalName}
        </Box>
        )
      </Box>
    </Alert>
  )
}
